module.exports = __webpack_public_path__ + "static/SoinSansNeue-Roman-c71bc4cbce1002698d82dc8fd11ae0ab.otf";